module.exports = __webpack_public_path__ + "static/media/live.a35a5fb7.svg";